<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>CONFIRMAR</h2>
</mat-dialog-content>

<mat-dialog-content class="modal-body">
  {{mensaje}}
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button type="button" class="btn btn-naranja" (click)="confirmado()" mat-button>Si</button>
  <button type="button" class="btn btn-naranja2" (click)="cerrarDialogo()" mat-button>No</button>
</mat-dialog-actions>
